import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  AUTH_SERVICE,
  IAuthService,
  AuthState,
  CHAT_SERVICE,
  IChatService,
} from '@infinitform/platform-core';
import { EDITOR_ENVIRONMENT, EditorEnvironmentConfig } from '../config/editor-environment';

@Injectable({ providedIn: 'root' })
export class EditorAuthFacade {
  private readonly authService = inject<IAuthService>(AUTH_SERVICE);
  private readonly chatService = inject<IChatService>(CHAT_SERVICE);
  private readonly env = inject<EditorEnvironmentConfig>(EDITOR_ENVIRONMENT);

  isAuthenticated(): Observable<boolean> {
    return this.authService.isAuthenticated();
  }

  getAuthState(): Observable<AuthState> {
    return this.authService.getAuthState();
  }

  getUserName(): Observable<string> {
    return this.authService.getAuthState().pipe(
      map((state) => state.user?.name ?? 'User')
    );
  }

  hasSubscription(): boolean {
    return !this.env.subscriptionsEnabled;
  }

  hasAiChatFeature(): boolean {
    return this.chatService.isAvailable();
  }

  hasCadEditorFeature(): boolean {
    return this.env.cadEditor;
  }

  hasRestrictedAccess(): boolean {
    return false;
  }

  isViewOnly(): boolean {
    return false;
  }
}
